import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";

export default class FundiinPayment extends DComponent {
  constructor({
    parent,
    id,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("FundiinPayment"),
    }, true);
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "FundiinPayment");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    $(".info-fundiin").on("click", () => {
      $("#fundiin_modal").modal('toggle');
      this.hide();
    });

    $("#fundiin_modal").on("hidden.bs.modal", () => {
      $("html, body").css("overflow", "auto");
      // $(".modal#" + this.id).modal("show");
    });

    // $(".modal#" + this.id).on("hidden.bs.modal", () => {
    //   $("html, body").css("overflow", "auto");
    // });
  }

  show() {
    $("html, body").css("overflow", "hidden");
    // $(".modal#" + this.id).modal("show");
    $("#fundiin_modal").modal('show');
  }

  hide() {
    $(".btn-ok", this.element).removeClass("loading");
    // $(".modal#" + this.id).modal("hide");
    $("#fundiin_modal").modal('hide');
  }
}